import React from 'react';
import { ActionIcon, Anchor, Box, Text } from '@mantine/core';
import { IconChevronLeft } from '@tabler/icons-react';

type Props = {
    title: string;
    onBack?: () => void;
    onRemove?: () => void;
    removeLabel?: string;
};

const FilterViewHead: React.FC<Props> = ({ title, onBack, onRemove, removeLabel = 'Togli' }) => (
    <Box className="bd-fp-view-head">
        {onBack ? (
            <ActionIcon className="bd-fp-back" variant="subtle" color="gray" onClick={onBack} aria-label="Torna a tutti i filtri">
                <IconChevronLeft size={18} stroke={1.8} />
            </ActionIcon>
        ) : null}
        <Text component="span" className="bd-fp-view-title">{title}</Text>
        {onRemove ? <Anchor component="button" type="button" size="xs" c="dimmed" onClick={onRemove}>{removeLabel}</Anchor> : null}
    </Box>
);

export default FilterViewHead;
